import BreadCrumb from "@/src/components/Shared/BreadCrumbs";
import SingleCountry from "@/src/components/Home/singleCountry";

import server from "../../src/api/server";
import { useIntl } from "react-intl";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { checkRedirect } from "@/src/components/helpers/functions";
import { buildSeoAlternates } from "@/src/components/helpers/seo";

const SingleCountryPage = ({ singleCountry }) => {
  const { locale, formatMessage } = useIntl();
  const { asPath } = useRouter();
  const { canonical, languageAlternates } = buildSeoAlternates(asPath, locale);

  return (
    <>
      <NextSeo
        title={singleCountry?.metaTitle?.[locale]}
        description={singleCountry?.metaDescription?.[locale]}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />

      <BreadCrumb
        heading={singleCountry?.name?.[locale]}
        description={`${formatMessage({
          id: "main",
        })} / ${formatMessage({
          id: "recruitmentCountries",
        })} / ${singleCountry?.name?.[locale]?.slice(0, 50)}`}
      />
      <div className="wrapper ">
        <SingleCountry data={singleCountry} />
      </div>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const { id } = ctx.params;
  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  try {
    const countryRes = await server.get(`/countries/${id}`);
    const personnelsRes = await server.get("/personnels");

    const personnels = personnelsRes?.data?.data?.personnels || [];
    const filteredPersonnels = personnels.filter((person) => {
      const country = person?.country;
      const countryId = country?._id || country?.id || country;
      return String(countryId) === String(id);
    });

    if (!countryRes?.data?.data?.country) {
      return { notFound: true };
    }

    return {
      props: {
        singleCountry: {
          ...countryRes?.data?.data?.country,
          personnels: filteredPersonnels,
        },
      },
    };
  } catch (error) {
    console.error(
      "Failed to fetch blog:",
      error?.response?.status || error.message,
    );

    return {
      notFound: true,
    };
  }
}

export default SingleCountryPage;
